(() => {
  const initUseCase = (root) => {
    if (!root || root.dataset.ypUsecaseBound === 'true') return;
    root.dataset.ypUsecaseBound = 'true';

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-yp-scroll]');
      if (!button || !root.contains(button)) return;
      const target = document.getElementById(button.getAttribute('data-yp-scroll'));
      if (!target) return;
      const direction = Number(button.getAttribute('data-dir')) || 1;
      target.scrollBy({ left: target.clientWidth * 0.78 * direction, behavior: 'smooth' });
    });

    const grid = root.querySelector('[data-yp-selected-grid]');
    const pagination = root.querySelector('[data-yp-selected-pagination]');
    const prev = root.querySelector('[data-yp-selected-prev]');
    const next = root.querySelector('[data-yp-selected-next]');
    const status = root.querySelector('[data-yp-selected-status]');
    const items = grid ? Array.from(grid.querySelectorAll('[data-yp-selected-item]')) : [];
    if (!grid || !pagination || !prev || !next || !items.length) return;

    const compactMq = window.matchMedia('(max-width: 989px)');
    const savedPage = window.history.state?.ypUseCaseSelectedPage;
    let page = Number.isSafeInteger(savedPage) && savedPage >= 0 ? savedPage : 0;
    let touchX = null;
    let touchY = null;
    const getPageSize = () => compactMq.matches ? 4 : 6;

    // Persist the selected page on this browser-history entry only.
    // On mobile, navigating Back from a product restores this pagination state.
    const rememberPage = () => {
      try {
        const current = window.history.state;
        const state = current && typeof current === 'object' && !Array.isArray(current) ? current : {};
        window.history.replaceState({ ...state, ypUseCaseSelectedPage: page }, '');
      } catch (_) {
        // Never block normal browsing if history state is unavailable.
      }
    };

    const renderPage = () => {
      const pageSize = getPageSize();
      const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
      page = Math.max(0, Math.min(page, totalPages - 1));

      items.forEach((item, index) => {
        const visible = index >= page * pageSize && index < (page + 1) * pageSize;
        item.classList.toggle('is-page-hidden', !visible);
        item.hidden = !visible;
        item.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });

      const hidePagination = totalPages <= 1;
      pagination.classList.toggle('is-page-hidden', hidePagination);
      pagination.hidden = hidePagination;
      prev.disabled = page <= 0;
      next.disabled = page >= totalPages - 1;

      const baseLabel = grid.dataset.ypSelectedLabel || 'Selected product examples';
      grid.setAttribute('aria-label', `${baseLabel}, page ${page + 1} of ${totalPages}`);
      if (status) status.textContent = `Page ${page + 1} of ${totalPages}`;
    };

    prev.addEventListener('click', () => {
      if (page <= 0) return;
      page -= 1;
      rememberPage();
      renderPage();
    });
    next.addEventListener('click', () => {
      const totalPages = Math.ceil(items.length / getPageSize());
      if (page >= totalPages - 1) return;
      page += 1;
      rememberPage();
      renderPage();
    });

    grid.addEventListener('touchstart', (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      touchX = touch.clientX;
      touchY = touch.clientY;
    }, { passive: true });

    grid.addEventListener('touchend', (event) => {
      if (touchX === null || touchY === null) return;
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - touchX;
      const dy = touch.clientY - touchY;
      touchX = null;
      touchY = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;

      const totalPages = Math.ceil(items.length / getPageSize());
      if (dx < 0 && page < totalPages - 1) {
        page += 1;
        rememberPage();
        renderPage();
      } else if (dx > 0 && page > 0) {
        page -= 1;
        rememberPage();
        renderPage();
      }
    }, { passive: true });

    const reset = () => { page = 0; rememberPage(); renderPage(); };
    if (typeof compactMq.addEventListener === 'function') compactMq.addEventListener('change', reset);
    else if (typeof compactMq.addListener === 'function') compactMq.addListener(reset);
    renderPage();
  };

  const boot = (scope = document) => {
    if (scope.matches && scope.matches('.yp-usecase')) initUseCase(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('.yp-usecase').forEach(initUseCase);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();